import { SpacingArrayData, SpacingData } from "@interfaces/spacing"

const getStyleArray = (value: SpacingArrayData, isDesktop: boolean) => {
  if (isDesktop) {
    if (value.lg) {
      return value.lg.map((val) => convertUnit(val)).join(' ')
    }

    if (value.sm) {
      return value.sm.map((val) => convertUnit(val)).join(' ')
    }
  } else {
    if (value.sm) {
      return value.sm.map((val) => convertUnit(val)).join(' ')
    }
    return '0'
  }
}

const getStyle = (value: SpacingData, isDesktop: boolean) => {
  if (isDesktop) {
    if (value.lg == 0) {
      return '0'
    } 
    if (value.lg) {
      return convertUnit(value.lg)
    }
    if (value.sm) {
      return convertUnit(value.sm)
    }
  } else {
    if (value.sm) {
      return convertUnit(value.sm)
    }
    return '0'
  }
}

const getStyleSpacing = (value: SpacingData, isDesktop: boolean) => {
  if (isDesktop) {
    if (value.lg == 0) {
      return value.lg
    }
    return value.lg || value.sm
  } else {
    if (value.sm) {
      return value.sm
    }
    return '0'
  }
}

const convertUnit = (value: number) => {
  return `${value / 10}rem`
}

export { getStyleArray, getStyle, getStyleSpacing, convertUnit }